import {
  Dic,
  Dates
} from '$utils'
export const tableOption = function () {
  return {
    view: '记录详情',
    page: true,
    selection: false,
    index: false,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: 'left',
    size: 'mini',
    maxHeight: '100%',
    labelWidth: '100px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '700px',
    emptyText: '暂无数据',
    exportDisabled: false,
    column: [{
        label: '告警时间',
        prop: 'alarmTime',
        span: 12,
        // columnWidth: 140,
        type: 'datetimerange',
        search: true,
        searchSlot: true,
        viewDisplay: true,
      },
      // {
      //   //   label: '告警标题',
      //   //   prop: 'alarmTitle',
      //   //   viewDisplay: true,
      //   //  // search: true,
      //   //   span: 12
      // },
      {
        label: '告警类型',
        prop: 'commonAlarmType',
        align: 'center',
        type: 'select',
        search: true,
        multiple: false,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        // columnWidth: 70,
        span: 12,
        dicData: Dic.find('SENU097003004'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU097003004', Number(value))
          }
          return ''
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU097003004', value) : ''
        },
      },
      // {
      //   label: '设备告警类型',
      //   prop: 'alarmType',
      //   align: 'center',
      //   type: 'select',
      //   multiple: false,
      //   addDisplay: true,
      //   editDisplay: true,
      //   viewDisplay: true,
      //   span: 3,
      // },

      {
        label: '告警处置状态',
        prop: 'alarmState',
        align: 'center',
        type: 'select',
        search: true,
        multiple: false,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        // columnWidth: 100,
        span: 12,
        dicData: Dic.find('SENU068'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU068', Number(value))
          }
          return ''
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU068', value) : ''
        },
      },

      {
        label: '告警级别',
        prop: 'alarmLevel',
        search: false,
        // columnWidth: 70,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        overHidden: true,
        slot: true,
        span: 12,
        type: 'select',
        dicData: Dic.find('SENU017'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU017', Number(value))
          }
          return ''
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU017', value) : ''
        },
      },
      // {
      //   label: '记录类型',
      //   prop: 'subSystem',
      //   // search: true,
      //   //searchSlot: true,
      //   span: 12,
      //   columnWidth: 90,
      //   hide: false,
      //   type: 'select',

      // },
      {
        label: '主机名称',
        type: 'select',
        filterable: true,
        prop: 'parentDeviceName',
        search: true,
        // columnWidth: 100,
        searchSlot: true,
        // columnWidth: 220,
        // addDisplay: false,
        // editDisplay: false,
        // viewDisplay: false,
        span: 24,
        dicData: [],
      },
      // {
      //   label: '主机编号',
      //   type: 'select',
      //   // searchSlot: true,
      //   prop: 'parentThirdAlarmDevId',
      //   span: 24,
      //   search: false,
      //   viewDisplay: true,
      //   dicData: [],
      // },
      {
        label: '部件名称',
        prop: 'deviceName',
        // columnWidth: 220,
        viewDisplay: true,
        search: true,
        span: 24
      },
      {
        label: '部件类型',
        prop: 'subDeviceMark',
        viewDisplay: true,
        search: false,
        // columnWidth: 120,
        span: 12,
        dicData: Dic.find('SENU094'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU094', Number(value))
          }
          return ''
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU094', value) : ''
        },
      },
      {
        label: '部件编号',
        prop: 'componentThirdAlarmDevId',
        search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        // columnWidth: 120,
        span: 12
      },
      // {
      //   label: '唯一标识号',
      //   prop: 'thirdAlarmDevId',
      //   span: 12,
      //   // columnWidth: 120,
      //   search: false,
      //   viewDisplay: true,
      // },
      {
        label: '报警',
        prop: 'multiAlarmType',
        search: false,
        // columnWidth: 120,
        viewDisplay: true,
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        overHidden: true,
        align: 'center',
        span: 12,
        type: 'select',
        dicData: Dic.find('SENU100'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU100', Number(value))
          }
          return ''
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU100', value) : ''
        },
      },
      {
        label: '报警所在位置',
        prop: 'buildingName',
        span: 24,
        align: 'center',
        viewDisplay: true,
      },
      {
        label: '处理人',
        prop: 'modifier',
        span: 24,
        align: 'center',
        viewDisplay: true,
      },
      {
        label: '处理时间',
        prop: 'modifyTime',
        span: 24,
        align: 'center',
        viewDisplay: true,
      },

    ]
  }
}

export const tapOption = function (that) {
  return {
    column: [{
        label: "执行人员",
        prop: 'tab1'
      },
      {
        label: "执行明细",
        prop: 'tab2'
      },
      {
        label: "告警明细",
        prop: 'tab3'
      }
    ]
  }
}
export const taskOption = function () {
  return {
    column: [{
        label: "任务名称",
        prop: 'taskName',
        span: 24
      },
      {
        label: "指派人",
        prop: 'creatorName',
        span: 8
      },
      {
        label: "任务类型",
        prop: 'taskType',
        dicData: Dic.find('SENU010'),
        span: 8
      },
      {
        label: "任务状态",
        prop: 'status',
        dicData: Dic.find('SENU012'),
        span: 8
      },
      {
        label: "优先级",
        prop: 'taskPriority',
        dicData: Dic.find('SENU008'),
        span: 8
      },
      // {
      //   label: "可见性",
      //   prop: 'taskVisibility',
      //   dicData: Dic.find('SENU009'),
      //   span: 16
      // },
      {
        label: "指派时间",
        prop: 'createTime',
        type: 'daterange',
        valueFormat: 'yyyy-MM-dd HH:mm:ss',
        formatter: function (row, value) {
          return value ? Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "";
        },
        span: 12
      },
      {
        label: "任务描述",
        prop: 'desc',
        span: 24
      }
    ]
  }
}